// Navbar.js
import React, { useCallback, useEffect, useState } from "react";
import "../Pages/HomePage.css";
import "../CSS/fonts.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRightFromBracket,
  faSignal,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import userSession from "../Constant/auth";
import { APP_SERVICES_URL } from "../Constant/constant";
import sensenCroppedLogo from "../Assets/sensen-cropped.png";
import forecourt from "../Assets/forecourt.png";
import driveoff from "../Assets/driveoff.png";
import payment from "../Assets/payment.png";
// import shoplift from "../Assets/shopliftIcon.png";
import { NotificationManager, NotificationContainer } from "react-notifications";

const Navbar = ({
  handleShowDriveOff,
  handleShowIOU,
  handleShowPaymentModal,
  handleOpenSignalModal,
  handleShowStolenPlateModal,
  handleShowShopliftingModal,
  currentSiteEventsError,
  liveEventsError
}) => {
  const { CustID, authHeader, site } = userSession;
  const [isOnline, setIsOnline] = useState(false);
  const [isDeviceOnline, setIsDeviceOnline] = useState(navigator.onLine);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsDeviceOnline(navigator.onLine);
    }, 10000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);


  useEffect(() => {
    if (currentSiteEventsError) {
        NotificationManager.error(
          <div className="showNormalFont">
            Failed to fetch current site events.
          </div>,
          <div className="showNormalFont">Error</div>
        );
    }

    if (liveEventsError) {
      NotificationManager.error(
        <div className="showNormalFont">
          Failed to fetch live events.
        </div>,
        <div className="showNormalFont">Error</div>
      );
    }
  }, [currentSiteEventsError, liveEventsError]);


  const fetchDataOnlineStatus = useCallback(async () => {
    try {
      const response = await axios.get(
        `${APP_SERVICES_URL}/senapi/${CustID}/tunnelCheck?siteName=${site.name}`,
        {
          headers: {
            Authorization: authHeader,
          },
        }
      );

      // Assuming the API responds with a boolean value
      setIsOnline(true);
    } catch (error) {
      setIsOnline(false);
      // console.error("Error fetching tunnel status:", error);
    }
  }, [CustID, site, authHeader]);

  useEffect(() => {
    // Fetch data initially
    fetchDataOnlineStatus();

    // Set up interval to fetch data every 1 minute
    const intervalId = setInterval(fetchDataOnlineStatus, 60000);

    // Cleanup function
    return () => {
      clearInterval(intervalId);
    };
  }, [fetchDataOnlineStatus]);

  const statusClassName = isDeviceOnline
    ? isOnline
      ? "tunnelOnline"
      : "tunnelOffline"
    : "deviceOffline";

  const handleDriveOffClick = () => {
    const offcanvas = document.getElementById('offcanvasWithBothOptions');
    // Close offcanvas using data-bs-dismiss
    const closeBtn = offcanvas.querySelector('[data-bs-dismiss="offcanvas"]');
    if (closeBtn) {
      closeBtn.click();
    }

    setTimeout(() => {
      handleShowDriveOff();
    }, 350);
  };

  const handleIOUClick = () => {
    const offcanvas = document.getElementById('offcanvasWithBothOptions');
    const closeBtn = offcanvas.querySelector('[data-bs-dismiss="offcanvas"]');
    if (closeBtn) {
      closeBtn.click();
    }

    setTimeout(() => {
      handleShowIOU();
    }, 350);
  };

  const handlePaymentClick = () => {
    const offcanvas = document.getElementById('offcanvasWithBothOptions');
    const closeBtn = offcanvas.querySelector('[data-bs-dismiss="offcanvas"]');
    if (closeBtn) {
      closeBtn.click();
    }

    setTimeout(() => {
      handleShowPaymentModal();
    }, 350);
  };

  const handleShopliftingClick = () => {
    const offcanvas = document.getElementById('offcanvasWithBothOptions');
    const closeBtn = offcanvas.querySelector('[data-bs-dismiss="offcanvas"]');
    if (closeBtn) {
      closeBtn.click();
    }

    setTimeout(() => {
      handleShowShopliftingModal();
    }, 350);
  };


  return (
    <>
      <NotificationContainer />
      <nav className="navbar navbar-dark bg-dark fixed-top">
        <div className="container-fluid">
          <div style={{ position: "relative", width: "100%", height: "56px" }}>
            {/* First div - Top left */}
            <div
              style={{
                position: "absolute",
                top: "0",
                left: "0",
              }}
            >
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasWithBothOptions"
                aria-controls="offcanvasWithBothOptions"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            </div>

            {/* Second div - Center */}
            <div
              style={{
                position: "absolute",
                top: "0",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              <h3 className="navbar-brand" id="siteName">
                {site && site.name ? site.name.toUpperCase() : ''} Forecourt
              </h3>
            </div>

            {/* Third div - Top right */}
            <div
              style={{
                position: "absolute",
                top: "0",
                right: "0",
                color: "white",
              }}
            >
              <span
                id="stolen-plate"
                onClick={handleShowStolenPlateModal}
                style={{ cursor: "pointer" }}
              >
                Manage Stolen Plate
              </span>
              <span
                className={`signal-icon ${statusClassName}`}
                onClick={handleOpenSignalModal}
              >
                <FontAwesomeIcon icon={faSignal} />
              </span>
              <span
                className="logout-icon"
                data-bs-toggle="modal"
                data-bs-target="#logoutModal"
              >
                <FontAwesomeIcon icon={faRightFromBracket} />
              </span>
            </div>
          </div>
        </div>
      </nav>

      {/* Offcanvas with both scrolling and backdrop */}
      <div
        className="offcanvas offcanvas-start"
        data-bs-scroll="true"
        tabIndex="-1"
        id="offcanvasWithBothOptions"
        aria-labelledby="offcanvasWithBothOptionsLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasWithBothOptionsLabel">
            <img
              src={sensenCroppedLogo}
              alt="sensen#scancamLogo"
              className="img-fluid logo"
            />
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div
            id="menu-forecourt"
            className="menu-item d-flex flex-row align-items-center mb-2"
            type="button"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <div className="p-2 menu-image">
              <div
                className="d-flex img-thumbnail align-items-center justify-content-center"
                style={{ height: "100px", width: "100px" }}
              >
                <img src={forecourt} alt="Forecourt" />
              </div>
            </div>
            <div className="p-2 offcanvasText forecourttext">FORECOURT</div>
          </div>
          <div
            id="menu-Driveoff"
            className="menu-item d-flex flex-row align-items-center mb-2"
            onClick={handleDriveOffClick}
          >
            <div className="p-2 menu-image">
              <div
                className="d-flex img-thumbnail align-items-center justify-content-center"
                style={{ height: "100px", width: "100px" }}
              >
                <img src={driveoff} alt="Forecourt" />
              </div>
            </div>
            <div className="p-2 offcanvasText forecourttext">DRIVE OFF</div>
          </div>
          <div
            id="menu-iou"
            className="menu-item d-flex flex-row align-items-center mb-2"
            onClick={handleIOUClick}
          >
            <div className="p-2 menu-image">
              <div
                className="d-flex img-thumbnail align-items-center justify-content-center"
                style={{ height: "100px", width: "100px" }}
              >
                <img src={driveoff} alt="Forecourt" />
              </div>
            </div>
            <div className="p-2 offcanvasText forecourttext">IOU</div>
          </div>
          <div
            id="menu-forecourt"
            className="menu-item d-flex flex-row align-items-center mb-2"
            onClick={handlePaymentClick}
          >
            <div className="p-2 menu-image">
              <div
                className="d-flex img-thumbnail align-items-center justify-content-center"
                style={{ height: "100px", width: "100px" }}
              >
                <img src={payment} alt="Forecourt" />
              </div>
            </div>
            <div className="p-2 offcanvasText forecourttext">PAYMENT</div>
          </div>
          {/* <div
            id="menu-sholift"
            className="menu-item d-flex flex-row align-items-center mb-2"
            onClick={handleShopliftingClick}
          >
            <div className="p-2 menu-image">
              <div
                className="d-flex img-thumbnail align-items-center justify-content-center"
                style={{ height: "100px", width: "100px", overflow: "hidden" }}
              >
                <img
                  src={shoplift}
                  alt="Forecourt"
                  style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                />
              </div>
            </div>
            <div className="p-2 offcanvasText sholiftText">SHOPLIFTING</div>
          </div> */}

        </div>
      </div>
    </>
  );
};

export default Navbar;
